import { valuesIn } from "lodash";

let ID = () => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
};

let context = {
    currentOrganization: { id: "" },
    currentMembership: { type: "" },
};

LoadFromStorage();

function LoadFromStorage() {
    let storage = localStorage.getItem("organization");
    if (storage) {
        try {
            let organization = JSON.parse(storage);
            if (organization != null && organization.id) {
                SetOrganization(organization);
            }
        } catch (e) {}
    }
}

function SaveToStorage(organization) {
    localStorage.setItem("organization", JSON.stringify(organization));
    localStorage.setItem("redirects", "0");
}

let subscriptions = {} as { [key: string]: (context: any) => void };

function dispatch() {
    valuesIn(subscriptions).forEach((s) => s(context));
}

export function Context() {
    return context;
}

export function GetContext(subscription) {
    let id = ID();
    if (subscription) {
        subscriptions[id] = subscription;
        if (context.currentOrganization.id) {
            subscription(context);
        }
    }
    return id;
}

export function UnsubscribeContext(id) {
    if (subscriptions[id]) delete subscriptions[id];
}

export function SetOrganization(organization) {
    context.currentOrganization = organization;
    SaveToStorage(organization);
    dispatch();
}

export function SetMembership(membership) {
    context.currentMembership = membership;
    dispatch();
}
